import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import dayjs from 'dayjs'
import imgUrl from './directive/img'
import animateOnScroll from './directive/animate-on-scroll'
import VueLazyload from 'vue-lazyload'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import VueVirtualScroller from 'vue-virtual-scroller'
var VueScrollTo = require('vue-scrollto')

import './style.css'

import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import './style/element-variables.scss'

import './style/common.scss'

import { findDetailContent, findLevelListByName, formatNumber } from './utils'


import Empty from '@/components/w-empty.vue'
import Banner from '@/components/common-banner.vue'
import Wrapper from '@/components/wrapper-box/index.vue'
import Breadcrumb from '@/components/breadcrumb.vue'

Vue.component('Empty', Empty)
Vue.component('Banner', Banner) 
Vue.component('WrapperBox', Wrapper)
Vue.component('Breadcrumb', Breadcrumb)

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueScrollTo)

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('@/assets/images/empty.png'),
  loading: require('@/assets/images/logo.png'),
  attempt: 1
})

Vue.use(VueVirtualScroller)

Vue.directive('img-url', imgUrl)
Vue.directive('animate-on-scroll', animateOnScroll)

Vue.prototype.dayjs = dayjs
Vue.prototype.findDetailContent = findDetailContent
Vue.prototype.findLevelListByName = findLevelListByName
Vue.prototype.formatNumber = formatNumber
Vue.prototype.$setUrl = (url) => {
  if (url) {
		return url.startsWith('http') ? url : url.includes('static') && !url.includes('merch') ? process.env.VUE_APP_BASE_URL + '/merch' + url :  process.env.VUE_APP_BASE_URL + url
	}
	return ''
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
